module.exports = __webpack_public_path__ + "img/racecourse-durbanville-turf-1300.a3cf2c22.svg";